import { Component, ElementRef, Inject, AfterViewInit, OnInit, Injector } from "@angular/core";
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, FormBuilder, Validators } from "@angular/forms";
import { Router, Event } from "@angular/router";
import * as jQuery from "jquery";
import { DataService } from "../../../services/data/data.service";
import { quoteFilterTabsParams } from "../../quoteFilterTabs/quoteFilterTabs.list";
import { WorkspaceServiceService } from "../../../services/workspace-service.service";
import { GlobalGridModeService } from "../../../services/globalGridMode/globalGridMode.service";
import { HostListener } from "@angular/core";
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";
import { ISymbolBase } from "../../../interfaces/ISymbolBase";
import { SymbolTypeEnum } from "../../../enums/SymbolType.enum";
import { AppComponentBase } from "../../../services/AppComponentBase";
import {Providers} from "../../../enums/providers";

@Component({
    selector: "modal-addsymboltobasket",
    template: require('./addsymbolstobasket.component.html'),
    styles: [require('./addsymbolstobasket.component.css')]
})
export class addsymbolstobasketModal extends AppComponentBase {
    public _symbols: any = {};
    tabs: object = quoteFilterTabsParams();

    public _activeBasketSymbols: string[] = [];
    public scrollbarOptions = { axis: "yx", theme: "minimal-dark" };
    constructor(injector: Injector, public activeModal: NgbActiveModal) {
        super(injector);
    }

    public get symbols() {
        

        return this._symbols;
    }

    set symbolsList(v: string[]) {
        this._activeBasketSymbols = v;
    }

    get symbolsList() {
        return this._activeBasketSymbols;
    }

   public  set symbols(l: ISymbolBase) {
        console.log(this.symbolsList);


        l.forex = l.forex.filter(l=>{

            if(this.workspace.competitionAccountList.indexOf(this.workspace.activeAccountIdBySet)>-1 || this.workspace.currentProvider!=Providers.DEMO)
            {
            // console.log(this.workspace.currentTournaments[0].tournamentAssets);
                if(this.workspace.allowedForexSymbols.indexOf(l)>-1)//&& this.workspace.currentTournaments[0].tournamentAssets.Assets.indexOf(0))
                {
                    return true;
                }
                else
                {
                    return false;
                }
            }
            else
            {
                return true;
            };
        }
        );;








        let sortOrder = Object.assign([], this.symbolsList);
        let initSortOrder = Object.assign([], this.workspace.initOrderSymbol);

        /**FF FIX */
        sortOrder.forEach(v => {
            var index = initSortOrder.indexOf(v);
            if (index > -1) {
                initSortOrder.splice(index, 1);
            }
        });
        initSortOrder.reverse();
        initSortOrder = initSortOrder.concat(sortOrder.reverse());

        let v = Object.assign([], l);

        mapOrder(v.forex, initSortOrder, "");
        mapOrder(v.crypto, initSortOrder, "");
        mapOrder(v.equity, initSortOrder, "");
        mapOrder(v.commodity, initSortOrder, "");
        mapOrder(v.index, initSortOrder, "");
        mapOrder(v.bonds, initSortOrder, "");

        //  console.log(v.forex.reverse());

        this._symbols = v;
    }

    public addSymbols() {
        this.workspace.updateBasket(this.workspace.activeBasket, this.symbolsList);
        this.activeModal.close();
    }

    get activeTab(): SymbolTypeEnum {
        return this.workspace.activeSymbolType;
    }

    set activeTab(tabId: SymbolTypeEnum) {
        this.workspace.activeSymbolType = tabId;
    }

    updateCheckedSymbolsList(item: string, event: any) {
        if (event.target.checked == true) {
            let index = this.symbolsList.indexOf(item);
            if (index < 0) {
                this.symbolsList.push(item);
            }
        } else {
            let index = this.symbolsList.indexOf(item);
            if (index >= -1) {
                this.symbolsList.splice(index, 1);
            }
        }
    }

    private _searchValue: string = "";
    public get searchValue(): string {
        return this._searchValue;
    }
    public set searchValue(value: string) {
        this._searchValue = value;
    }

    public filterContains(item: string) {

        item = item.toLocaleLowerCase();

        if (item.includes(this.searchValue.toLocaleLowerCase()) || this.searchValue == "") {
            return true;
        }

        return false;
    }

    private _innerHeight: number = 0;

    public set innerHeight(v: number) {
        if (v < 400) {
            v = 400;
        }
        this._innerHeight = v;
    }

    public get innerHeight() {
        return this._innerHeight;
    }

    ngOnInit() {
        this.innerHeight = this.heightPercent * window.innerHeight;
    }

    private heightPercent: number = 0.6;

    ngAfterViewInit(): void {
        $(".scrollContainer").mCustomScrollbar({
            axis: "y",
            theme: "inset-3", // "minimal-dark",
            scrollbarPosition: "outside",
            alwaysShowScrollbar: 1, // 0,1,2
            scrollButtons: {
                enable: true
            },
            mouseWheel: {
                enable: true
            }
        });
    }

    @HostListener("window:resize", ["$event"])
    getScreenSize(event: Event) {
        this.innerHeight = this.heightPercent * window.innerHeight;
    }
}

export function mapOrder(array: any, order: any, key: any) {
    array.sort(function(a: any, b: any) {
        var A = a,
            B = b;

        if (order.indexOf(A) > order.indexOf(B)) {
            return -1;
        } else {
            return 1;
        }
    });

    return array;
}
